import React, { FC } from 'react'
import WelcomeLayout from '../../components/WelcomeLayout/WelcomeLayout'
import Error404 from '../../components/Error/Error404'

const NotFoundRoot: FC = () => {
	return (
		<WelcomeLayout>
			<Error404 />
		</WelcomeLayout>
	)
}

export default NotFoundRoot
